import React, { useState } from "react";
import { TextField, Paper, Box, Typography, CircularProgress, Alert } from "@mui/material";
import ActionButton from "../widgets/ActionButton";
import { styled } from "@mui/system";
import { useAppDispatch, useAppSelector, useReduxPrefState } from "../../app/hooks";
import { useNavigate
} from "react-router-dom";
import { resetPassword } from "../../app/features/auth/authActions";

const StyledBox = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100vh',
  padding: '2rem',
});

const StyledPaper = styled(Paper)({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  maxWidth: '400px',
  padding: '2rem',
});

const ResetPassword = () => {
  const [username, setUsername] = useReduxPrefState("lastLogin", "");
  const [isLoginRunning, setIsLoginRunning] = useState(false);
  const error = useAppSelector(state => state.auth.errorMessage);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleReset = async () => {
    setIsLoginRunning(true);
    try {
      await dispatch(resetPassword(username));
    }
    catch (error: any) {
      setIsLoginRunning(false);
    }
    setIsLoginRunning(false);
    navigate("/login");
  };

  return (
    <StyledBox>
      <StyledPaper elevation={3}>
        <Typography variant="h4" component="h1" gutterBottom>
          Reset password
        </Typography>
        {error && <Alert severity="error">{error}</Alert>}
        <TextField label="Username" variant="outlined" margin="normal" disabled={isLoginRunning} value={username} onChange={(e) => setUsername(e.target.value)} />
        <ActionButton type="submit" disabled={isLoginRunning} onClick={handleReset}>
          {isLoginRunning ? <CircularProgress size={24} /> : "Send reset link"}
        </ActionButton>
      </StyledPaper>
    </StyledBox>
  );
};

export default ResetPassword;